/* eslint-disable sort-keys-fix/sort-keys-fix */
import { TEACHER_ROUTE } from 'app/teacher/routing-constants/teacher-routing.constant';

export const GAMESHOW_ROUTE = {
  name: ':classId/gameshow',
  route(classId: string): string[] {
    return [...TEACHER_ROUTE.ACTIVE_CLASS.route(classId), 'gameshow'];
  },
  DEFAULT: '',

  LAUNCH: {
    name: 'launch/:publicUnitId',
    route(classId: string, publicUnitId: string): string[] {
      return [...GAMESHOW_ROUTE.route(classId), 'launch', publicUnitId];
    }
  },

  LAUNCH_LINKED: {
    name: 'launch/:publicUnitId/:baseActivityId',
    route(classId: string, publicUnitId: string, baseActivityId: string): string[] {
      return [...GAMESHOW_ROUTE.route(classId), 'launch', publicUnitId, baseActivityId];
    }
  },

  FEEDBACK: {
    name: 'feedback/:gameShowRunId/:attemptNumber',
    route(classId: string, gameShowRunId: string, attemptNumber: number): string[] {
      return [...GAMESHOW_ROUTE.route(classId), 'feedback', gameShowRunId, attemptNumber.toString()];
    }
  },

  GAME: {
    name: ':gameShowRunId/:attemptNumber',
    route(classId: string, gameShowRunId: string, attemptNumber: number): string[] {
      return [...GAMESHOW_ROUTE.route(classId), gameShowRunId, attemptNumber.toString()];
    },
  }
};
